import React, { useState, useEffect } from "react";
import { postData } from "../api/protectedApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TransactionLayout from "../component/dashboard/TransactionLayout";
import { handleExportData } from "../utils/exportUtils";
import { callDataByEndpoint } from "../utils/dataUtils";
import styles from "../component/dashboard/css/transaction.module.css";

const PayoutTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const limit = 10;

  const callData = (page) => {
    callDataByEndpoint("/user/payout_transactions", {
      page,
      limit,
      setData: setTransactions,
      setTotalCount,
      setIsLoading,
    });
  };

  useEffect(() => {
    callData(currentPage);
  }, [currentPage]);

  const handleExport = (type) => {
    handleExportData({
      endpoint: "/user/payout_transactions",
      columns,
      fallbackData: transactions,
      filename: "payout_transactions",
      type,
      postDataFn: postData,
      toastFn: toast,
    });
  };

  const filteredTransactions = transactions.filter((t) => {
    const q = searchQuery.toLowerCase();
    return (
      (t.walletAddress && t.walletAddress.toLowerCase().includes(q)) ||
      (t.requestId && t.requestId.toLowerCase().includes(q)) ||
      (t.status && t.status.toLowerCase().includes(q)) ||
      (t.remark && t.remark.toLowerCase().includes(q)) ||
      (t.amount && t.amount.toString().includes(q))
    );
  });

  const columns = [
    { key: "id", label: "ID" },
    { key: "walletAddress", label: "WALLET ADDRESS" },
    { key: "requestId", label: "REQUEST ID", render: (t) => t.requestId ? <span className={styles.reqIdBadge} title={t.requestId}>{t.requestId}</span> : "-" },
    { key: "amount", label: "AMOUNT" },
    { key: "status", label: "STATUS" },
    { key: "callbackUrl", label: "CALLBACK URL", render: (t) => t.callbackUrl ? t.callbackUrl : "-" },
    { key: "remark", label: "REMARK", render: (t) => t.remarks ? <span className={styles.remarkTag} title={t.remarks}>{t.remarks}</span> : "-" },
    { key: "date", label: "DATE" },
  ];

  return (
    <TransactionLayout
      title="Payout Transactions"
      subtitle="Monitor and audit outgoing crypto payouts, status confirmations, and callback webhooks."
      searchQuery={searchQuery}
      onSearchChange={(q) => { setSearchQuery(q); setCurrentPage(1); }}
      searchPlaceholder="Search by wallet, request ID, status, or remark..."
      onExport={handleExport}
      cardTitle="Payout Ledger"
      cardSubtitle="Real-time payout settlement ledger"
      columns={columns}
      data={filteredTransactions}
      isLoading={isLoading}
      emptyMessage="No Payout Transactions Found."
      pagination={{
        currentPage,
        totalCount,
        limit,
        onPageChange: (page) => setCurrentPage(page),
      }}
    />
  );
};

export default PayoutTransactions;
